"use strict";
window.APP = window.APP || {};
APP.IndexView = Backbone.View.extend({

	template: _.template($('#screen1Template').html()),

  // populate the html to the dom
  render: function () {
    this.$el.html(
    	this.template({})
    );
    return this;
  }
});